import { Bell, BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useNotifications, useMarkNotificationRead, enablePushNotifications } from "@/hooks/useNotifications";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { format } from "date-fns";

export default function NotificationBell() {
  const { data: notifs = [] } = useNotifications();
  const markRead = useMarkNotificationRead();
  const navigate = useNavigate();
  const unread = notifs.filter((n: any) => n.status !== "read").length;

  const handleEnablePush = async () => {
    const r = await enablePushNotifications();
    if (r.ok) toast.success("Push notifications enabled");
    else toast.error(r.reason || "Could not enable push");
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          {unread > 0 ? <BellRing className="h-5 w-5" /> : <Bell className="h-5 w-5" />}
          {unread > 0 && (
            <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-[10px] rounded-full h-4 min-w-[16px] px-1 flex items-center justify-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="p-3 border-b flex items-center justify-between">
          <div className="font-semibold text-sm">Notifications</div>
          <Button size="sm" variant="ghost" onClick={handleEnablePush}>Enable push</Button>
        </div>
        <div className="max-h-96 overflow-auto">
          {notifs.length === 0 && (
            <div className="p-6 text-center text-sm text-muted-foreground">No notifications</div>
          )}
          {notifs.map((n: any) => (
            <button
              key={n.id}
              onClick={() => {
                if (n.status !== "read") markRead.mutate(n.id);
                if (n.link_url) navigate(n.link_url);
              }}
              className={`w-full text-left px-3 py-2 border-b hover:bg-muted/50 ${n.status !== "read" ? "bg-muted/30" : ""}`}
            >
              <div className="text-sm font-medium">{n.title}</div>
              {n.body && <div className="text-xs text-muted-foreground mt-0.5">{n.body}</div>}
              <div className="text-[10px] text-muted-foreground mt-1">
                {format(new Date(n.created_at), "dd/MM/yyyy HH:mm")}
              </div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
